import CloseIcon from '@mui/icons-material/Close';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LogoutIcon from '@mui/icons-material/Logout';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import Person from '@mui/icons-material/Person';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  clearAllStorage,
  dialogVariants,
  extendedStyles,
  iconVariants,
  loginStyleS,
  overlayVariants,
  primaryColor,
  whiteColor,
} from '../../common/Top/topStyle';
import { topbarStyles } from '../../commonStyle/TopStyles';
import logo from '../../image/logo.png';

const Topbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const user = useSelector((state) => state?.values?.loginValues?.[0] || {});
  const { name } = user?.user || {
    name: 'Guest',
  };

  const handleLogout = () => {
    clearAllStorage();
    navigate('/');
  };

  return (
    <>
      <Box p={2} sx={extendedStyles.topbarContainer}>
        <Grid container justifyContent="space-between" alignItems="center">
          {/* Left side - Logo and Title */}
          <Grid item xs={12} sm={6} md={7} lg={7} xl={8}>
            <Box display="flex" alignItems="center" gap={2}>
              <Box sx={topbarStyles.logoContainer || { height: '40px' }}>
                <img
                  src={logo}
                  alt="Hospital Logo"
                  style={{ height: '100%', maxHeight: '40px' }}
                />
              </Box>
              <Typography variant="h3" fontWeight={'bold'} sx={loginStyleS.title}>
                உள்நோயாளி வருகையாளர் மேலாண்மை அமைப்பு
              </Typography>
            </Box>
          </Grid>

          {/* Right side - User info and logout */}
          <Grid item xs={12} sm={6} md={5} lg={5} xl={4}>
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              gap={2}
              sx={topbarStyles.rightMenu}
            >
              <Typography variant="h3" sx={topbarStyles.userName}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Person sx={{ fontSize: 24, color: primaryColor }} />
                  {name || 'Guest'}
                </Box>
              </Typography>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button
                  variant="contained"
                  startIcon={<LogoutIcon />}
                  sx={loginStyleS.ButtonLogout}
                  onClick={() => setOpen(true)}
                >
                  Logout
                </Button>
              </motion.div>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <AnimatePresence>
        {open && (
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="xs"
            fullWidth
            PaperComponent={({ children }) => (
              <motion.div
                variants={dialogVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                style={loginStyleS.motion_div}
              >
                {children}
              </motion.div>
            )}
            BackdropComponent={({ children }) => (
              <motion.div
                variants={overlayVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
                style={loginStyleS.motion_div2}
              >
                {children}
              </motion.div>
            )}
            BackdropProps={{ invisible: true }}
          >
            <DialogTitle sx={loginStyleS.dialogTitle}>
              <Box display="flex" alignItems="center" gap={1}>
                <motion.div
                  variants={iconVariants}
                  initial="initial"
                  animate="animate"
                >
                  <LocalHospitalIcon />
                </motion.div>
                <span>Hospital Session Logout</span>
              </Box>
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{ color: whiteColor }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                padding: 3,
                background: whiteColor,
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
                textAlign="center"
                p={2}
              >
                <motion.div
                  animate={{
                    y: [0, -5, 0],
                    transition: {
                      repeat: Infinity,
                      duration: 2,
                    },
                  }}
                >
                  <MedicalServicesIcon
                    sx={{ fontSize: 60, color: primaryColor }}
                  />
                </motion.div>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 'bold', color: primaryColor }}
                >
                  End Your Hospital Session?
                </Typography>
                <Typography sx={{ color: '#555' }}>
                  For security reasons, your session will be terminated and
                  you'll need to authenticate again to access the hospital
                  system.
                </Typography>
              </Box>
            </DialogContent>
            <Box sx={loginStyleS.contentBox}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button
                  onClick={() => setOpen(false)}
                  variant="outlined"
                  sx={loginStyleS.contentBox2}
                >
                  Cancel
                </Button>
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button
                  onClick={handleLogout}
                  variant="contained"
                  startIcon={<LogoutIcon />}
                  sx={loginStyleS.contentBoxButton}
                >
                  Logout
                </Button>
              </motion.div>
            </Box>
          </Dialog>
        )}
      </AnimatePresence>
    </>
  );
};

export default Topbar;
